module.exports = __webpack_public_path__ + "static/media/arrow_back.3d4d37c2.svg";